import AddButton from "./AddButton";
import TaskList from "./Tasks/TaskList";

const MainContent = () => {
  return (
    <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <AddButton />
        <TaskList />
      </main>
    </div>
  );
};

export default MainContent;
